import { render, staticRenderFns } from "./ArBalanceForBank.vue?vue&type=template&id=54595d88&scoped=true"
import script from "./ArBalanceForBank.vue?vue&type=script&lang=js"
export * from "./ArBalanceForBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54595d88",
  null
  
)

export default component.exports